import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import { isVersionUS } from "../services/versionService";

const nationalityOptionFirst = isVersionUS ? "USA" : "GBR";

export const useGetNationalities = () => {
    const {
        isFetching: isLoading, data: nationalities, error,
    } = useQuery({
        queryKey: ["nationalities"],
        queryFn: () => axiosManager.get$("/parent/api/nationalities").then((response) => response?.data),
        retry: 0,
    });

    const nationalitiesOptions = (nationalities || []).map((item) => ({
        value: item.countryCode,
        label: item.name,
        id: item.countryCode,
        key: item.countryCode,
    })).sort((a) => (a.id === nationalityOptionFirst ? -1 : 1));

    return {
        isLoading,
        nationalities: nationalities || [],
        error,
        nationalitiesOptions,
    };
};
